<template>
<tooltip>
    <span slot="trigger" class="odr-hint">
        <span class="odr-hint__underline">
            <slot></slot>
        </span>
        <span class="odr-hint__q">?</span>
    </span>

    <div slot="content">
        <tpl :content="eTitle"></tpl>
    </div>
</tooltip>
</template>
<script>
import tooltip from './tooltip.vue'
import '../styles/hint.scss'

export default {
    props: {
        title: {
            type: String,
            _descr: 'Text shown on mouse over',
        },
    },
    data () {
        return {
            eTitle: null,
        }
    },
    mounted () {
        let hintContent = this.$el.querySelector('[data-hint-content]')
        this.eTitle = hintContent ? hintContent.innerHTML : this.title
    },
    components: {
        tooltip,
        tpl: require('./tpl.vue').default,
    },
}
</script>
